export const COLORS = {
  primary: '#f9c784',
  primaryIntense: '#e9a54c',
  background: '#141414',
  dark: '#242424',
  darkGray: '#3c3c3c',
  gray: '#a2a2a2',
  opacityGray: '#a2a2a291',
  light: '#ebebeb'
};
